module.exports = __webpack_public_path__ + "assets/img/choose_payment.b65d5f10.svg";